export const connection = (userId) => {
  return {
    userId: userId
  }
}

export const shootingsSearch = {
  category: 'Search',
  action: 'shootings-search',
  label: 'Shooting search'
}

export const shootingsSearchReset = {
  category: 'Search',
  action: 'shootings-search_reset',
  label: 'Shooting search reset'
}

export const shootingsSeeMore = {
  category: 'Click',
  action: 'shootings-search_see_more',
  label: 'Shootings search see more'
}

export const shootingsAdd = {
  category: 'Add',
  action: 'shootings-create_shooting',
  label: 'Shootings create shooting'
}

export const shootingsDownloadOriginal = {
  category: 'Download',
  action: 'shootings-download_shooting_original',
  label: 'Shootings download shooting'
}

export const shootingsDownloadStamped = {
  category: 'Download',
  action: 'shootings-download_shooting_stamped',
  label: 'Shootings download shooting'
}

export const shootingsViewShootingSimple = {
  category: 'Click',
  action: 'shootings-view_shooting_simple',
  label: 'Shootings view shooting'
}

export const shootingsViewShootingDetailed = {
  category: 'Click',
  action: 'shootings-view_shooting_detailed',
  label: 'Shootings view shooting'
}

export const shootingsReplayDms = {
  category: 'Click',
  action: 'shootings-replay_dms',
  label: 'Shootings replay dms'
}

export const shootingsWebinaireRedirect = {
  category: 'Click',
  action: 'shootings-webinaire_redirect',
  label: 'Shootings webinaire redirect'
}

export const shootingsDisplayPlayer = {
  category: 'Click',
  action: 'shootings-display_player',
  label: 'Shootings display player'
}

export const shootingsSendPlayer = {
  category: 'Click',
  action: 'shootings-send_player',
  label: 'Shootings send player'
}
